import { useSelector } from '@xstate/react'
import { useOrgsActions, useOrgsService, useRequested } from 'providers'
import { useCallback, useRef } from 'react'
import { OrgData, OrgServiceMetaObject } from 'types/orgs'
import { noop } from 'utils'
type OrgsWithCurrState = {
  id: string
  orgs: OrgData[]
} & OrgServiceMetaObject

export const useOrgs = (): [
  OrgData[] | undefined,
  (c: string) => void,
  boolean,
  string | undefined
] => {
  const { list: listOrgs } = useOrgsActions()
  const requested = useRequested()
  const countryRef = useRef<string>('')
  const request = useSelector(
    // @ts-ignore
    useOrgsService(),
    (state: any) => {
      const content = state.context.content[countryRef.current]
      return content
    }
  ) as OrgsWithCurrState | undefined
  const orgs = request?.orgs
  const currentState = request?.__meta
  const loading = currentState?.status === 'pending'
  const error =
    currentState?.status === 'failed' ? currentState.displayError : ''
  const list = useCallback(
    (code) => {
      countryRef.current = code
      if (
        countryRef.current &&
        requested.current.orgs.list.find(
          ({ input }) => input.countryCode === countryRef.current
        ) === undefined
      ) {
        listOrgs({ countryCode: countryRef.current }).catch(noop)
      }
    },
    [listOrgs, countryRef, requested]
  )

  return [orgs, list, loading, error]
}
